module.exports = __webpack_public_path__ + "img/ground-mountain-day.1a7e3c6a.png";